import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@commercial-website/icons';
import { ButtonLink } from '../../atoms/button/button-link';
const CAMPAIGN_POSTER = 'https://cdn.sanity.io/images/x38k87cj/production/46897882eaeb46fb468d989fe3d426026826d255-1920x1080.jpg?auto=format&fit=max&w=1920';
// Prod campaign hero clip (Sanity CDN).
export const bannerHeroVideoMedia = {
    video: {
        webm: 'https://cdn.sanity.io/files/x38k87cj/production/f7a22a18565a92e5a27637de13b789e0fc786071.webm',
        mp4: 'https://cdn.sanity.io/files/x38k87cj/production/a2c33d6795d22968bbb8d0c0492b36dcde2cc394.mp4',
    },
    poster: CAMPAIGN_POSTER,
};
// The prod campaign master carries an audio track; this optimised WebM/MP4 (+poster) is the English
// 30s ad, encoded via the preparing-web-videos skill with audio kept, so the sound toggle has a real
// clip to drive in the interactive story.
export const audibleBannerHeroVideoMedia = {
    video: {
        webm: 'https://cdn.sanity.io/files/x38k87cj/production/e037726ae0721c42f60ec5941a25687c48dcf8c4.webm',
        mp4: 'https://cdn.sanity.io/files/x38k87cj/production/86c1a4ee64d21359adb4efb4c6cf213467b17edb.mp4',
    },
    poster: 'https://cdn.sanity.io/images/x38k87cj/production/5f692b294b12c8d3fbe5cd02f824e9f11174302b-1920x1080.jpg?auto=format&fit=max&w=1920',
    description: 'Pleo campaign ad',
};
// The English WebVTT for the campaign clip (Sanity CDN). Shared by the desktop and mobile variants.
export const campaignCaptionsTrack = {
    src: 'https://cdn.sanity.io/files/x38k87cj/production/47d8e04ccb9a63df4386893042b03a341a4fd42a.vtt',
    lang: 'en',
    label: 'English',
};
// Audible campaign clip plus a real `<track kind="captions">`. `mobileVideo` is set so both the
// desktop and mobile variants render (and each carries the caption track), exercising the WCAG
// captions markup — the native `<track>` and the forced `crossOrigin` — that the captions island
// drives in production.
export const captionedBannerHeroVideoMedia = {
    video: {
        webm: 'https://cdn.sanity.io/files/x38k87cj/production/e037726ae0721c42f60ec5941a25687c48dcf8c4.webm',
        mp4: 'https://cdn.sanity.io/files/x38k87cj/production/86c1a4ee64d21359adb4efb4c6cf213467b17edb.mp4',
    },
    mobileVideo: {
        webm: 'https://cdn.sanity.io/files/x38k87cj/production/e037726ae0721c42f60ec5941a25687c48dcf8c4.webm',
        mp4: 'https://cdn.sanity.io/files/x38k87cj/production/86c1a4ee64d21359adb4efb4c6cf213467b17edb.mp4',
    },
    poster: 'https://cdn.sanity.io/images/x38k87cj/production/5f692b294b12c8d3fbe5cd02f824e9f11174302b-1920x1080.jpg?auto=format&fit=max&w=1920',
    description: 'Pleo campaign ad',
    captions: campaignCaptionsTrack,
};
export const bannerHeroMock = {
    media: {
        image: (_jsx("img", { src: "https://cdn.sanity.io/images/x38k87cj/production/46897882eaeb46fb468d989fe3d426026826d255-1920x1080.jpg?auto=format&fit=max&w=1920", alt: "", loading: "eager" })),
    },
    title: 'For the craft of finance',
    children: (_jsx(ButtonLink, { variant: "pink", icon: _jsx(Arrow, {}), label: "Explore the platform", href: "/en/explore-platform-demo", className: "w-full justify-between sm:w-auto sm:justify-center" })),
};
